import { styled } from "~/common/mui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ParagraphWithShowAll = ({ paragraph, initialLength = 92 }: { paragraph: string; initialLength?: number }) => {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      {showAll ? paragraph : `${paragraph.substring(0, initialLength)}...`}{" "}
      <ShowAllLink onClick={() => setShowAll(!showAll)}>
        {showAll ? t("searchPage.refinements.showLess") : t("availabilityTable.showAll")}
      </ShowAllLink>
    </>
  );
};

export default ParagraphWithShowAll;

const ShowAllLink = styled("a")({
  cursor: "pointer",
});
